import React, { Component } from 'react';

import PropTypes from 'prop-types';

import Dropdown from '../../Dropdown';

export default class BoardPicker extends Component {
  static propTypes = {
    boards: PropTypes.array,
    onBoardSelected: PropTypes.func,
    placeholder: PropTypes.string,
  };

  static defaultProps = {
    placeholder: 'Choose a board',
  };

  onBoardSelected = (boardID) => {
    const { boards, onBoardSelected } = this.props;
    const board = boards.filter((board) => board._id === boardID)[0];
    onBoardSelected(board);
  };

  render() {
    const { boards } = this.props;
    return (
      <div className="boardPicker">
        <Dropdown
          defaultSelectedName={null}
          onChange={this.onBoardSelected}
          options={boards.map((board) => ({
            name: board._id,
            render: board.name,
          }))}
          placeholder={this.props.placeholder}
        />
      </div>
    );
  }
}
